<!--注册-->
<template>
	<div class="page-body center-wrap">
		<div class="form-div">
			<div class="title txt-24 txt-w7">{{ $t('创建GPT账户') }}</div>
			<div class="title2 txt-16 txt-w4">{{ $t('使用您的电子邮箱进行注册') }}</div>
			<div class="tabs dis-fle txt-16">
				<!-- <span class="item">电话</span> -->
				<span class="item active">{{ $t('邮箱') }}</span>
			</div>

			<div class="form-item">
				<label class="label txt-20">{{ $t('邮箱') }}</label>
				<div class="value">
					<el-input v-model="account" :placeholder="$t('请输入账号')" size="medium" clearable></el-input>
				</div>
			</div>
			<!-- <div class="form-item">
				<label class="label txt-20">{{ $t('验证码') }}</label>
				<div class="value">
					<el-input v-model="captcha" :placeholder="$t('请输入验证码')" size="medium">
						<template slot="suffix">
							<span class="txt txt-16 cur-poi" @click="btnCode">{{ $t('发送验证码') }}</span>
						</template>
					</el-input>
				</div>
			</div> -->
			<div class="form-item">
				<label class="label txt-20">{{ $t('密码') }}</label>
				<div class="value">
					<el-input v-model="password" :placeholder="$t('请输入密码')" size="medium" type="password" clearable
						show-password></el-input>
				</div>
			</div>
			<div class="form-item">
				<label class="label txt-20">{{ $t('确认密码') }}</label>
				<div class="value">
					<el-input v-model="passwordS" :placeholder="$t('请再次输入密码')" size="medium" type="password" clearable
						show-password></el-input>
				</div>
			</div>
			<div class="form-item">
				<label class="label txt-20">{{ $t('资金密码') }}</label>
				<div class="value">
					<el-input v-model="pay_password" :placeholder="$t('请输入资金密码')" size="medium" type="password" clearable
						show-password></el-input>
				</div>
			</div>
			<div class="form-item">
				<label class="label txt-20">{{ $t('确认资金密码') }}</label>
				<div class="value">
					<el-input v-model="pay_passwordS" :placeholder="$t('请再次输入资金密码')" size="medium" type="password" clearable
						show-password></el-input>
				</div>
			</div>
			<div class="form-item">
				<div class="value">
					<el-input v-model="code" :placeholder="$t('邀请码(选填)')" size="medium" clearable></el-input>
				</div>
			</div>
			<div class="form-item">
				<el-checkbox v-model="checked">{{ $t('我已阅读同意') }}</el-checkbox>
				<!-- <router-link to="" class="txt-14 cur-poi" style="color: var(--color-txt2);margin-left: 12px;">
					<span>GPT</span><span style="color: var(--color-txt1);margin: 0px 12px;">{{ $t('服务条款') }}</span>
				</router-link> -->
				<label class="txt-14 cur-poi" style="color: var(--color-txt2);margin-left: 12px;">
					<span>GPT</span><span style="color: var(--color-txt1);margin: 0px 12px;"
						@click="$nav.go('/pc/article?type=6')">{{ $t('服务条款') }}</span>
				</label>
			</div>

			<div class="but" @click="register">{{ $t('注册') }}</div>

			<router-link to="/pc/login" class="qt txt-14 cur-poi">
				<span>{{ $t('登录') }}</span>
			</router-link>
		</div>
	</div>
</template>
<script>
import {
	post
} from '@/http/request'

export default {
	components: {},
	data() {
		return {
			account: '',
			password: '',
			passwordS: '',
			pay_password: '',
			pay_passwordS: '',
			code: '',
			captcha: "",
			checked: false,
		};
	},
	mounted() {
		this.code = this.$route.params.invite_code || ''
	},
	beforeUnmount() { },
	methods: {
		btnCode() {
			post(this.$apis.emsSend, {
				email: this.account
			}).then(res => {
				if (res.code == 1) {
					this.$notify.success(res.msg)
				}
			})

		},
		register() {
			if (this.passwordS != this.password) {
				this.$notify.error('两次密码不一致');
				return
			}
			if (this.pay_passwordS != this.pay_password) {
				this.$notify.error('两次密码不一致');
				return
			}
			if (!this.checked) {
				this.$notify.error('请勾选协议');
				return
			}
			post(this.$apis.register, {
				account: this.account,
				password: this.password,
				pay_password: this.pay_password,
				invite_code: this.code,
				captcha: this.captcha
			}).then(res => {
				if (res.code == 1) {
					this.$store.commit('setUserInfo', res.data.userinfo)
					this.$store.commit('setToken', res.data.userinfo.token)
					this.$notify.success(res.msg)
					// 延时跳转，让用户看到提示
					setTimeout(() => {
						this.$nav.go('/pc/home')
					}, 800)
				}
			})
		}
	},
}
</script>
<style lang="scss" scoped>
@import "~@/style/pc/login.scss";

.txt {
	display: inline-block;
	color: var(--color-txt1);
	line-height: 42px;
	padding-right: 10px;
}
</style>